export default "__VITE_ASSET__CIZvcNOn__"